import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'db-medic-users',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'db-medic-users-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {                           
                        transKey: 'breadcrumbs.db-medic-users-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "db-medic-users-index" */ '@/modules/configurations/database-load/db-medic-users/views/Index.vue')
        }
    ]
}